/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Event_Pause_DescriptionInputs */

const en_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We’re resolving a technical issue with this event. See you back here at 12:00 pm (GMT+8) on April 22!`)
};

const ar_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نحن نعمل على حل مشكلة تقنية في هذا الحدث. نراكم هنا مجددًا في الساعة 12:00 ظهرًا (GMT+8) في 22 أبريل!`)
};

const de_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir beheben derzeit ein technisches Problem mit diesem Ereignis. Wir sehen uns hier wieder am 22. April um 12:00 Uhr (GMT+8)!`)
};

const es_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos resolviendo un problema técnico con este evento. ¡Nos vemos aquí de nuevo el 22 de abril a las 12:00 p. m. (GMT+8)!`)
};

const fr_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous résolvons un problème technique avec cet événement. On se retrouve ici le 22 avril à 12h00 (GMT+8) !`)
};

const it_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stiamo risolvendo un problema tecnico con questo evento. Ci vediamo qui il 22 aprile alle 12:00 (GMT+8)!`)
};

const ja_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在、このイベントに関する技術的な問題を解決中です。4月22日午後12:00（GMT+8）にまたお会いしましょう！`)
};

const ko_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 이 이벤트의 기술적인 문제를 해결하고 있습니다. 4월 22일 오후 12:00(GMT+8)에 여기서 다시 만나요!`)
};

const pt_br_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos resolvendo um problema técnico com este evento. Esperamos você de volta aqui no dia 22 de abril, às 12h00 (GMT+8)!`)
};

const ru_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы устраняем техническую проблему в этом событии. До встречи здесь 22 апреля в 12:00 (GMT+8)!`)
};

const th_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรากำลังแก้ไขปัญหาทางเทคนิคของกิจกรรมนี้ แล้วพบกันที่นี่ในวันที่ 22 เมษายน เวลา 12:00 น. (GMT+8)!`)
};

const tr_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu etkinlikle ilgili teknik bir sorunu çözüyoruz. 22 Nisan saat 12:00'de (GMT+8) burada tekrar görüşmek üzere!`)
};

const zh_cn_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们正在修复活动的技术问题，4 月 22 日中午 12:00（GMT+8）将恢复活动进行！`)
};

const zh_tw_dialog_event_pause_description = /** @type {(inputs: Dialog_Event_Pause_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們正在修復活動的技術問題，4 月 22 日中午 12:00（GMT+8）將恢復活動進行！`)
};

/**
* | output |
* | --- |
* | "We’re resolving a technical issue with this event. See you back here at 12:00 pm (GMT+8) on April 22!" |
*
* @param {Dialog_Event_Pause_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_event_pause_description = /** @type {((inputs?: Dialog_Event_Pause_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Event_Pause_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_event_pause_description(inputs)
	if (locale === "ar") return ar_dialog_event_pause_description(inputs)
	if (locale === "de") return de_dialog_event_pause_description(inputs)
	if (locale === "es") return es_dialog_event_pause_description(inputs)
	if (locale === "fr") return fr_dialog_event_pause_description(inputs)
	if (locale === "it") return it_dialog_event_pause_description(inputs)
	if (locale === "ja") return ja_dialog_event_pause_description(inputs)
	if (locale === "ko") return ko_dialog_event_pause_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_event_pause_description(inputs)
	if (locale === "ru") return ru_dialog_event_pause_description(inputs)
	if (locale === "th") return th_dialog_event_pause_description(inputs)
	if (locale === "tr") return tr_dialog_event_pause_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_event_pause_description(inputs)
	return zh_tw_dialog_event_pause_description(inputs)
});